import {
    CREATE_CAMPAIGN_SUCCESS,
    DELETE_CAMPAIGN_SUCCESS,
    FETCH_CAMPAIGNS,
    FETCH_CAMPAIGNS_FAILURE,
    FETCH_CAMPAIGNS_SUCCESS,
    CAMPAIGN_LIST_FILTER_UPDATE,
    CAMPAIGN_LIST_FILTER_CATEGORY,
    CAMPAIGN_LIST_PAGE,
    CAMPAIGN_LIST_SORT,
    FETCH_CAMPAIGN,
    FETCH_CAMPAIGN_FAILURE,
    FETCH_CAMPAIGN_SUCCESS,
    SORT_ASC,
    UPDATE_CAMPAIGN_SUCCESS,
} from 'store/actions/types';
import paginationHelper from 'helpers/pagination';
import reducerHelper from 'helpers/reducers';
import utils from 'helpers/utils';

const initialState = {
    data: {},
    field: 'name',
    filter: {},
    filterCategory: reducerHelper.FILTER_BASIC,
    ids: [],
    loading: false,
    localisation: {},
    offset: 0,
    order: SORT_ASC,
    page: 1,
    size: 12,
    total: 0,
};

export default function campaigns(state = initialState, action) {
    switch (action.type) {
        case FETCH_CAMPAIGN:
        case FETCH_CAMPAIGNS:
            return Object.assign({}, state, {
                loading: true,
            });

        case FETCH_CAMPAIGNS_FAILURE:
        case FETCH_CAMPAIGN_FAILURE:
            return Object.assign({}, state, {
                data: {},
                filter: {},
                ids: [],
                loading: false,
                offset: 0,
                size: 0,
                total: 0,
            });

        case FETCH_CAMPAIGNS_SUCCESS:
            // Converts the Array of results to an Object based on the id.
            const convertResultsToData = utils.mapToObject(action.payload.results, (value) => {
                return value.id;
            });

            const newIds = action.payload.results.map(function (result) {
                return result.id;
            });

            return Object.assign({}, state, {
                data: Object.assign({}, state.data, convertResultsToData),
                ids: newIds,
                loading: false,
                offset: action.payload.offset,
                size: action.payload.size,
                total: parseInt(action.payload.total, 10),
            });

        case FETCH_CAMPAIGN_SUCCESS:
            return Object.assign({}, state, {
                data: Object.assign({}, state.data, {
                    [action.response.id]: action.response,
                }),
                ids: [
                    ...state.ids,
                    ...action.response.id,
                ],
            });

        case CREATE_CAMPAIGN_SUCCESS:
            return Object.assign({}, state, {
                data: Object.assign({}, state.data, {
                    [action.id]: action.response,
                }),
                loading: false,
            });

        case UPDATE_CAMPAIGN_SUCCESS:
            return Object.assign({}, state, {
                data: Object.assign({}, state.data, {
                    [action.id]: action.response,
                }),
                loading: false,
            });

        case CAMPAIGN_LIST_FILTER_CATEGORY:
            const filter = Object.assign({}, state.filter, action.payload.filter);

            return Object.assign({}, state, {
                filter: filter,
            });

        case CAMPAIGN_LIST_PAGE:
            return Object.assign({}, state, {
                offset: paginationHelper.generateNewOffset(action.payload.page, state.size),
                page: action.payload.page,
            });

        case CAMPAIGN_LIST_SORT:
            return Object.assign({}, state, {
                field: action.payload.field,
                order: action.payload.order,
            });

        case DELETE_CAMPAIGN_SUCCESS:
            const { id } = action.payload;

            const deletedData = reducerHelper.removeItemFromObject(state.data, id);
            const deletedStateIds = reducerHelper.removeItemFromArrayOfStrings(state.ids, id);

            return Object.assign({}, state, {
                data: deletedData,
                ids: deletedStateIds,
                loading: false,
                total: state.total - 1,
            });

        case CAMPAIGN_LIST_FILTER_UPDATE:
            const filteredValues = reducerHelper.normaliseState(initialState, action.payload);

            return Object.assign({}, state, filteredValues);

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/store/reducers/campaignsReducer.js